import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import createRibbonViewState from 'owa-editor-ribbonplugin/lib/utils/createRibbonViewState';
import { getIsAutomaticReplyEnabled, getPeriodicReplyEnabled, getBlockCalendarEnabled, getBlockCalendarTitle, getDeclineNewInvitationsEnabled, getEditorViewStateMessageContent, getEditorViewStateDeclineMeetingContent, getEditorViewStateOutsideOrgContent, getSendRepliesOutsideOrgEnabled, getSendRepliesToContactsOnlyEnabled, getStartDate, getEndDate, } from '../selectors/getStoreProperties';
/**
 * Utility function to get data for initial state
 * @returns data to update initial state of type AutomaticRepliesOptionsState
 */
export default function getDataForInitialState() {
    return {
        isAutomaticReplyEnabled: getIsAutomaticReplyEnabled(),
        periodicReplyEnabled: getPeriodicReplyEnabled(),
        blockCalendarEnabled: getBlockCalendarEnabled(),
        blockCalendarTitle: getBlockCalendarTitle(),
        declineExistingCalendarEventsEnabled: false,
        declineNewInvitationsEnabled: getDeclineNewInvitationsEnabled(),
        editorViewStateMessage: createEditorViewState(getEditorViewStateMessageContent(), false),
        editorViewStateDeclineMeeting: createEditorViewState(getEditorViewStateDeclineMeetingContent(), false),
        editorViewStateOutsideOrg: createEditorViewState(getEditorViewStateOutsideOrgContent(), false),
        ribbon: createRibbonViewState(),
        sendRepliesToContactsOnlyEnabled: getSendRepliesToContactsOnlyEnabled(),
        sendRepliesOutsideOrgEnabled: getSendRepliesOutsideOrgEnabled(),
        startDate: getStartDate(),
        endDate: getEndDate(),
    };
}
//# sourceMappingURL=getDataForInitialState.js.map